import React from 'react';
import './Spinner.css';

export default function Spinner({ size = 24, color = 'var(--gold)' }) {
  return (
    <div className="spinner-wrap">
      <div className="spinner" style={{ width: size, height: size, borderTopColor: color }} />
    </div>
  );
}

export function PageLoader({ label = 'Loading…' }) {
  return (
    <div className="page-loader">
      <div className="spinner" style={{ width: 32, height: 32, borderTopColor: 'var(--gold)' }} />
      <span>{label}</span>
    </div>
  );
}

export function InlineLoader() {
  return <div className="inline-loader"><div className="spinner" style={{ width: 16, height: 16, borderTopColor: 'var(--gold)' }} /></div>;
}
